import Wrapper from './styles';
import React, { useState } from 'react';
import { Title, Content, Label, SliderContainer } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import dataJson from 'shared/data';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { Select } from './styles';
import { setFilter } from 'redux/general/actions';
import { Input } from './styles';

const FilterInputs = () => {
  const [name, setName] = useState('');
  const [hospital, setHospital] = useState('');
  const dispatch = useDispatch();
  
  const onChangeName = (e) => {
    const v = e.target.value;
    setName(v);
    dispatch(setFilter('name', v, true));
  }

  const onChangeHospital = (e) => {
    const v = e.target.value;
    setHospital(v);
    dispatch(setFilter('institution', v, true));
  }


  return(
    <Wrapper>
      <Title>Buscador</Title>
      <Content>
        <Input placeholder="ESCRIBE UN NOMBRE" value={name} onChange={onChangeName}/>
        <Input placeholder="ESCRIBE UN HOSPITAL" value={hospital} onChange={onChangeHospital}/>
      </Content>
    </Wrapper>
  )
}

export default FilterInputs;